import { component } from 'picoapp'
import { zelektor, loopify } from '@/lib/utility-functions.js'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const gender = localStorage.getItem('spreeglee_gender') || 'unisex'
    const { link: links, trigger: triggers } = zelektor(node)
    const siteHeader = document.querySelector('header.header');


    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    loopify(links).forEach(l => l.addEventListener('click', redirectGender))
    
    loopify(links).forEach(l => l.addEventListener('mouseover', e => {
        if (siteHeader.className.match(/\bgender--men\b/) || siteHeader.className.match(/\bgender--women\b/)) {
            setGenderTemp(e.currentTarget)
        }
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && window.location.pathname === '/') {
            redirectGender(e);
        }
    }))

    loopify(triggers).forEach(t => t.addEventListener('click', clickTrigger))

    ctx.on('gender:set', ({ gender }) => update(gender))


    /*******************************************************************************************************************************************/
    /* Init
    /*******************************************************************************************************************************************/
    initTriggers()
    update(gender)


    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function update(gender) {
        node.classList.remove(`${node.classList[0]}--men`, `${node.classList[0]}--women`, `${node.classList[0]}--unisex`)
        node.classList.add(`${node.classList[0]}--${gender}`)
    }
    
    function redirectGender(e) {
        let shouldRedirect = true;
        if (siteHeader.className.match(/\bgender--men\b/) == null && siteHeader.className.match(/\bgender--women\b/) == null) {
            shouldRedirect = false;
        }

        e.preventDefault()

        const thisLink = e.currentTarget
        const { gender } = thisLink.dataset
        const { href } = thisLink

        setGender(gender)
        
        if (shouldRedirect) {
            location.href = href
        }
    }

    function setGender(gender) {
        localStorage.setItem('spreeglee_gender', gender)
        
        ctx.emit('gender:set', state => {
            return {
                gender: gender
            }
        })
    }

    function clickTrigger(e) {
        const thisTrigger = e.currentTarget
        
        loopify(triggers).forEach(t => t.classList.remove('is-active'))
        thisTrigger.classList.add('is-active')

        setGenderTemp(thisTrigger)
    }

    function setGenderTemp(trigger) {
        const { gender } = trigger.dataset
        
        if (!localStorage.getItem('spreeglee_gender')) localStorage.setItem('spreeglee_gender',gender)

        ctx.emit('gender:setTemp', state => {
            return {
                gender: gender
            }
        })
    }

    function initTriggers() {
        loopify(triggers).forEach(t => t.classList.remove('is-active'))

        let currentGender
        const savedGender = localStorage.getItem('spreeglee_gender') || 'unisex'

        if (savedGender === 'unisex' && node.dataset.default) {
            currentGender = node.dataset.default
        } else {
            currentGender = savedGender
        }
        
        const currentTrigger = loopify(triggers).find(t => t.dataset.gender === currentGender)

        if (currentTrigger) currentTrigger.classList.add('is-active')
    }
})